export enum CorporationStaleTimeEnum {
  GetCorporationById = 60000,
  GetCorporationQuota = 60000,
}
